export default "__VITE_ASSET__BcbOOVpy__"